<template>
  <div class="page">
    <div class="header-section">
        <div class="card-info">
            <nut-row>
                <nut-col :span="24">
                    <div class="flex-content">
                        <span>ICCID：{{cardDetail.iccid}}</span>
                        <span class="iconfont icon-copy"></span>
                    </div>
                </nut-col>
            </nut-row>
            <nut-row>
                <nut-col :span="24">
                    <div class="flex-content">MSISDN：{{cardDetail.msisdn}}</div>
                </nut-col>
            </nut-row>
            <nut-row>
                <nut-col :span="24">
                    <div class="flex-content">卡状态：{{cardDetail.showStatus}}</div>
                </nut-col>
            </nut-row>
        </div>
        <div class="card-product">
            <nut-row class="row-card-current">
                <nut-col :span="24">
                    <div class="flex-content">
                        <span class="text-product">当前套餐：{{cardDetail.productName}}</span>
                    </div>
                </nut-col>
            </nut-row>
            <nut-row class="row-card-product">
                <nut-col :span="24">
                    <div class="flex-content">
                        <span v-if="!!cardDetail.expireTime">套餐将于 {{cardDetail.expireTime}} 到期</span>
                        <span v-else>套餐使用完，请续费！</span>
                    </div>
                </nut-col>
            </nut-row>
        </div>
    </div>
    <div class="content-section">
        <nut-tab @tab-switch="tabSwitch" :is-scroll="false" :def-index="0">
            <nut-tab-panel tab-title="订购套餐">
                <div class="product-list">
                    <div class="product-item" :class="{current: currentIndex===index}" v-for="(item,index) in productList" :key="index" @click="payDetails(item,index)">
                        <div class="product-item-up">
                            <div class="product-name">
						        {{item.productName}}
                            </div>
                            <div class="product-price">
                                <span>¥ {{item.price}}</span>
                            </div>
                        </div>
                        <div class="product-item-down">
                            <div class="product-expire">
                                <span>有效期:{{item.day}}天</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nut-tab-panel>
            <nut-tab-panel tab-title="加油包">
                <div class="product-list">
                    <div class="product-item" :class="{current: currentIndex===index}" v-for="(item,index) in productList" :key="index">
                        <div class="product-item-up">
                            <div class="product-name">
						        {{item.productName}}
                            </div>
                            <div class="product-price">
                                <span>¥ {{item.price}}</span>
                            </div>
                        </div>
                        <div class="product-item-down">
                            <div class="product-expire">
                                <span>有效期:{{item.day}}天</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nut-tab-panel>
        </nut-tab>
    </div>
    <nut-button v-if="productList.length>0" block shape="circle" @click="createOrder">购买</nut-button>
    <!-- 悬浮窗 -->
    <div class="suspension-window">
        <div class="suspension-kefu" @click="handleChat">
            <span class="iconfont icon-kefu"></span>
        </div>
    </div>
  </div>
</template>

<script> 
import wx from "weixin-js-sdk";
import { wx_Auth } from "@/api/api.js"; //获取微信信息
import {wx_mxGetDetail , wx_mxGetProducts , wx_noShowPay} from "@/api/api.js"
export default {
  name: "cardNoShow",
  data() {
    return {
      code:undefined,
      cardDetail:{},
      type:"1",
      productList:[],
      currentIndex: 0,
      currentProduct:{}
    };
  },
  methods: {
    tabSwitch(index){
        this.currentIndex = 0
        if(index == 0){
           this.type = "1"
        }else{
           this.type = "2" 
        }
        this.mxInitProduct()
    },
    mxInitCard(){
        let iccid = this.$route.query.iccid
        wx_mxGetDetail({iccid}).then(res=>{
            this.cardDetail = res.data.data
        })
    },
    mxInitProduct(){
        let iccid = this.$route.query.iccid
        let type = this.type
        wx_mxGetProducts({iccid,type}).then(res=>{
            this.productList = res.data.data
            console.log(res.data.data[0])
            this.currentProduct = res.data.data[0]
        })
    },
    payDetails(item,index){
        this.currentIndex = index;
        this.currentProduct = item
    },
    createOrder(){
        let params ={
          iccid:this.cardDetail.iccid,
          price:this.currentProduct.price,
          productId:this.currentProduct.productId,
          ip:"11.28.33.12",
          type: "MWEB"
        }
        params.channel = localStorage.getItem("channel")
        if(this.isWeiXin()){
          params.code = this.code;
          params.type = "JSAPI";
        }
        let that = this
        
        wx_noShowPay(params).then(res=>{
          if (res.data.code == 200) {
            if(this.isWeiXin()){
              let orderNum = res.data.data.orderNum
              wx.chooseWXPay({
                timestamp: res.data.data.timeStamp,
                nonceStr: res.data.data.nonceStr, 
                package: res.data.data.packageValue, 
                signType: res.data.data.signType, 
                paySign: res.data.data.paySign, 
                success: function(res) {
                    that.$router.push({
                        name: "result",
                        query: {
                            orderNum: orderNum,
                        }
                    });
                }
              })
            }else{
                let form = document.createElement('form');
                document.body.appendChild(form);
                form.method = "post";
                form.action = res.data.data.mwebUrl;
                form.submit();
                document.body.removeChild(form); 
            }
          }else{
            this.$toast.fail(res.data.message);
          }
        })
    },
    initBrowser(){
        if (this.isWeiXin()) {
          this.code = localStorage.getItem("code");
          this.handelWxConfig()
        }
    },
    //获取微信信息
    handelWxConfig() {
      let params = {
        url: window.location.href,
        channel:localStorage.getItem("channel")
      };
      wx_Auth(params).then(res => {
        let dataObj = res.data.data;
        this.datas = res.data.data;
        let getAppid = dataObj.appId;
        let getTimestamp = dataObj.timestamp;
        let getNonceStr = dataObj.nonceStr;
        let getSignature = dataObj.signature;
        wx.config({
          debug: false,
          appId: getAppid,
          timestamp: getTimestamp,
          nonceStr: getNonceStr,
          signature: getSignature,
          jsApiList: ["chooseWXPay"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {}
          });
        });
      });
    },
    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger"
    },
    handleChat(){
        window.location.href="https://chat.qianhaiyunling.com/im/#/pages/chat?clientId=1747941862162960384&userId="+this.cardDetail.iccid;
    }
  },
  created() {
    this.mxInitCard()
    this.mxInitProduct()
    this.initBrowser()
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.page{
    font-size: 14px;
    width: 100%;
    height: 100vh;
    background: #ffffff;
    .header-section{
        padding: 15px 15px 20px 15px;
        background: linear-gradient(to bottom, #E10602 0%, #FAADAD 100%);
        color: white;
        border-radius: 0 0 5px 5px;
        .card-info{
            margin-bottom: 10px;
            padding: 5px 5px;
            .flex-content{
                font-weight: 300;
                font-size: 1rem;
                line-height: 28px;
                display: flex;
                flex-direction: row;
                align-items: center;
                .iconfont{
                    font-size: 1.5rem;
                    margin-left: 4px;
                }
            }
        }
        .card-product{
            background-color: #ffffff;
            color: #000000;
            font-weight: 300;
            font-size: 0.8rem;
            .row-card-current{
                padding: 20px 20px;
                .text-product{
                    font-size: 1.2rem;
                    color: #000000;
                    font-weight: 700;
                }
            }
            .row-card-product{
                padding: 8px 20px;
                background-color: #D4DFFD;
                color:#3c96f3
            }
        }
    }
    .content-section{
       /deep/ .nut-tab{
            background: #ffffff;
            border: 0px solid #ffffff;
            .nut-tab-link{
                font-size: 1rem;
            }
            .nut-tab-item{
                height: calc(100vh - 230px);
            }
        }
        .product-list {
            margin-top: 20px;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, minmax(0px, 1fr));
            height: 8rem;
            gap: 8px 12.48px;
            padding-bottom: 200px;
            .product-item {
                box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.06), 0 5px 12px 4px rgba(0, 0, 0, 0.04);
                height: 100%;
                border-radius: 10px;
                font-size: 1rem;
                font-weight: bold;
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 8px;
                
                .product-item-up{
                    padding: 2px 2px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .product-name{
                        font-size: 0.9rem;
                        line-height: 50px;
                        font-weight: 700;
                        color: #000;
                    }
                    .product-price{
                        color: #E10602;
                    }
                    
                }
                .product-item-down{
                    .product-expire{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-radius: 0 0 10px 10px;
                        line-height: 34px;
                        background: #FAADAD;
                    }
                }
                &.current {
                    // background: #E5F6FE;
                    border: 1px solid #E10602;
                    .product-expire{
                        background: #E10602;
                    }

                }
            }
        }
    }
    .suspension-window{
        position: fixed; 
        bottom: calc(100vh - 600px); 
        right: 10px;
        width: 50px;
        height: 50px;
        background-color: #E10602;
        opacity: 0.6; 
        line-height: 50px; 
        border-radius: 50%; 
        z-index: 100; 
        .suspension-kefu{
            display: flex;
            justify-content: center;
            align-content: center;
            .iconfont{
                font-size: 2.0rem;
            }
        }
    }
    /deep/ .nut-button{
        position: fixed; 
        bottom: 1px
    }
}
</style>
